// original mapping table can be found at:
// https://wiki.financial.com/confluence/pages/viewpage.action?pageId=27755244#Times&SalesArchitektur-ConditionsMapping

export const conditionMappings = {
  T: 'FORM T',
  '@ TI': 'ODD',
  '@ T': 'FORM T',
  '@FT': '1265',
  '@FTI': 'REUTER',
  '@F I': 'REUTER',
  '@  I': 'ODD',
  TI: 'ODD',
  TB: '705',
  UI: '865',
  'N TI': '8185',
  'N TB': '8145',
  FTI: '1325',
  TP: '775',
  I: 'ODD',
  'F I': '1065',
  ODD: 'NBDLT',
  AUT: 'AUTO',
  SPR: 'SPREAD',
  STL: 'STL',
  MSW: 'M_SWEEP',
  '4 B': '2275',
  '@ TW': '795',
  '@ TP': '775',
  Z: 'SOLD',
  'N WT': '8235',
  'R T': '11875',
  U: 'XTS',
  FT: '1265',
  '@7 V': 'CON',
  '@7 I': '32694',
  '@ UI': 'REUTER',
  'N T': '8125'
};

/**
 * Map ASG condition to tRic condition
 *
 * returns the original condition if no mapping could be found
 *
 * @param {string} value ASG condition
 */
export function mapCondition(value) {
  if (value === undefined) {
    return value;
  }
  return conditionMappings[value.trim()] || value;
}
